import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {ISurveySelected, ISurveySelectedEvent, SurveyFormItemComponentInterface} from '../../../../interface/component';
import {IHttpSetting} from '../../../../interface/dataset-params';
import {IAnswers, SurveyQuestionStructure} from '../survey/survey.component';
import {MatRadioChange} from '@angular/material/radio';

@Component({
    selector: 'noos-survey-radio',
    templateUrl: './survey-radio.component.html',
    styleUrls: ['./survey-radio.component.scss']
})
@NoosFormTypeService.register('survey-radio')
export class SurveyRadioComponent implements OnInit, AfterViewInit, SurveyFormItemComponentInterface {

    prop: SurveyQuestionStructure;
    isFilter = false;
    thisAppearance: any = 'outline';
    setting: IHttpSetting;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    @Input()
    index = 0;

    answers?: ISurveySelected[];
    isView = false;

    selectedValue: EventEmitter<ISurveySelectedEvent> = new EventEmitter<ISurveySelectedEvent>();
    selectedAnswers: ISurveySelected[] = [];

    isValue = false;
    valueLabel = '';
    selectedText = '';
    inValue = '';

    constructor() {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {

        if (this.isView) {
            if (this.answers !== undefined && this.answers.length > 0) {

                const inSelectedAnswer = this.prop.answers.filter(x => x.id === this.answers[0].value);
                if (inSelectedAnswer.length > 0) {
                    this.valueLabel = inSelectedAnswer[0].value_label;
                    this.isValue = inSelectedAnswer[0].require_value;
                    this.inValue = this.answers[0].ext_value;
                }

            }
        }

    }

    onSelected($event: MatRadioChange) {

        this.isValue = ($event.value as IAnswers).require_value;
        if (($event.value as IAnswers).require_value) {
            this.valueLabel = ($event.value as IAnswers).value_label;
        }
        this.selectedText = ($event.value as IAnswers).selected_warning;

        this.selectedAnswers = [];
        this.selectedAnswers.push({
            value: ($event.value as IAnswers).id, title: ($event.value as IAnswers).text,
            point: ($event.value as IAnswers).point,
            ext_value: '',
            requireValue: ($event.value as IAnswers).require_value
        });
        this.selectedValue.emit({question: this.prop, answers: this.selectedAnswers});
    }

    getChecked(item: IAnswers) {
        if (this.answers !== undefined) {
            return this.answers.filter(x => x.value === item.id).length > 0;
        }
        return false;
    }

    onKeyup($event: KeyboardEvent) {
        this.selectedAnswers[0].ext_value = this.inValue;
        this.selectedValue.emit({question: this.prop, answers: this.selectedAnswers});
    }
}
